import type { MetricsResponse } from '@/common/api/models/metricsResponse';

import fixtureDoc from '../../../../docs/contracts/ai-tutor-metrics-fixture.json';

type FixtureStates = keyof typeof fixtureDoc;

export type AiTutorMetricsFixtureState = 'ready' | 'tooFew' | 'empty' | 'ungated';

export function getAiTutorMetricsFixtureState(
  searchParams: URLSearchParams,
): AiTutorMetricsFixtureState | 'error' {
  if (searchParams.get('forceError') === '1') {
    return 'error';
  }
  if (searchParams.get('gated') === 'ungated') {
    return 'ungated';
  }
  const from = searchParams.get('from') ?? '';
  if (from.startsWith('2020')) {
    return 'empty';
  }
  const excludePaste = searchParams.get('excludePasteHeavy');
  const excludeFirst = searchParams.get('excludeFirstTryPasses');
  if (excludePaste === 'false' || excludeFirst === 'false') {
    return 'ready';
  }
  return 'tooFew';
}

export function loadAiTutorMetricsFixture(
  state: AiTutorMetricsFixtureState,
): MetricsResponse {
  return fixtureDoc[state as FixtureStates] as MetricsResponse;
}

/** Maps a metrics request URL to the contract fixture state. */
export function pickAiTutorFixtureFromRequestUrl(requestUrl: string): AiTutorMetricsFixtureState | 'error' {
  const url = new URL(requestUrl, 'http://localhost:8000');
  return getAiTutorMetricsFixtureState(url.searchParams);
}
